module.exports = __webpack_public_path__ + "assets/img/zzuj_bn.5ebee9a5.png";